import { datePresetRange } from 'library/helpers/accessLogHelpers';
import { removeEmptyOrNull } from 'library/helpers/utility';
import { VISITOR_ACTIVITY_DEFAULT_FILTERS } from './slice';

// Visitor activity request shaping (filters → params → cache key), shared by the saga and the card.

const PRESET_DAYS = { '7d': 7, '30d': 30 };

// Filters → GET /logs/visitors/activity params (siteID aside). Presets use the server's `days` window; Today
// and Custom send the range, recomputed at call time so a tab left open overnight moves on.
export const visitorActivityParams = (filters, page, pageSize) => {
	const f = { ...VISITOR_ACTIVITY_DEFAULT_FILTERS, ...filters };
	const range = f.time === 'custom' ? { startDate: f.startDate, endDate: f.endDate } : datePresetRange(f.time);
	const days = PRESET_DAYS[f.time];
	return removeEmptyOrNull({
		days,
		dateFrom: days ? undefined : range?.startDate,
		dateTo: days ? undefined : range?.endDate,
		status: f.status !== 'all' ? f.status : undefined,
		personIDs: f.personIDs.length ? f.personIDs.join(',') : undefined,
		deviceIDs: f.deviceIDs.length ? f.deviceIDs.join(',') : undefined,
		page,
		pageSize
	});
};

// How many filters differ from the default (the Filter pill's badge).
export const countVisitorActivityFilters = (filters) =>
	[
		filters.status !== 'all',
		filters.time !== VISITOR_ACTIVITY_DEFAULT_FILTERS.time,
		filters.personIDs.length > 0,
		filters.deviceIDs.length > 0
	].filter(Boolean).length;

// The ONE spelling of a visitor-activity page key: '<scopeKey>?<sorted params>'.
export const visitorActivityCacheKey = (scopeKey, params) =>
	`${scopeKey}?${Object.keys(params)
		.sort()
		.map((k) => `${k}=${params[k]}`)
		.join('&')}`;
